import {
  FunctionComponent,
  HTMLProps,
  MutableRefObject,
  AllHTMLAttributes,
} from 'react';
import { FieldInputProps, FieldMetaProps } from 'formik';
import { EButtonType } from '../../control/button/button.types';

export type TButtonSubmit = {
  title?: string;
  isLoading?: boolean;
  styleType?: EButtonType;
};

/*
export type TGenericHTMLAttribInterface<T extends TGenericHTMLCompInterface> =
    | TextareaHTMLAttributes<T>
    | InputHTMLAttributes<T>
    | SelectHTMLAttributes<T>;
*/

export type TFormikErrorWrapper<A extends TGenericHTMLCompInterface> = {
  meta?: FieldMetaProps<A>;
};

export type TFormikPropsWrapperChildProps<T> = {
  meta?: FieldMetaProps<T>;
  name: string;
} & Partial<FieldInputProps<T>> &
  AllHTMLAttributes<T>;

export type TFormikErrorWrapperChildProps<T> = {
  myRef?: MutableRefObject<T>;
  isValidating?: boolean;
  isError?: boolean;
  name: string;
} & Partial<FieldInputProps<T>> &
  AllHTMLAttributes<T>;

export type TGenericHTMLCompInterface =
  | HTMLInputElement
  | HTMLSelectElement
  | HTMLTextAreaElement;

export type TFormikPropsWrapper = {
  name: string;
};

export type TFormikInput = {
  id?: string;
  name: string;
  placeholder?: string;
  disabled?: boolean;
  multiple?: boolean;
  inputProps?: HTMLProps<HTMLInputElement>;
  component?: FunctionComponent;
  options?: { key: string; value: string }[];
  variant?: any;
  multiline?: boolean;
  rows?: number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
} & TFormikInputLabel;

export type TFormikInputLabel = {
  label?: string;
  labelPos?: ELabelPos;
  errorPos?: EErrorPos;
};

export enum ELabelPos {
  top = 'top',
  left = 'left',
}

export enum EErrorPos {
  bottom = 'bottom',
  right = 'right',
}
